import { 
  zlbApiSopManageInspectionStatusTypeGet,
  zlbApiSopManageQueryAllDistrictRuleGet,
  zlbApiSopManageInspectionLogCountGet,
  zlbApiSopManageInspectionRiskTypeGet,
  zlbApiSopTenantInspectionRemindersEventNoGet,
  zlbApiSopTenantInspectionEventReopenEventNoGet,
  zlbApiSopTenantInspectionPagePost,
  zlbApiSopManageInspectionDetailEventNoGet,
  zlbApiSopManageInspectionEventPageGet,
  zlbApiSopOrgInspectionTransferPost,
  zlbApiSopOrgInspectionPagePost,
  zlbApiSopManageQueryDistrictOrgRulePost,
} from '@/api/zlbSopContent';

export default {
  namespace: 'eventManage',
  state: {
   
  },

  effects: {
    // 获取巡检状态枚举
    * getStatusList ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionStatusTypeGet, payload);
      return res;
    },

    // 获取事件列表
    * getEventList ({ payload }, { call }) {
      const isTenant = window.location.pathname.includes('/claim/zoning-backstage/event-manage/list');
      const serviceReq = isTenant ? zlbApiSopTenantInspectionPagePost : zlbApiSopOrgInspectionPagePost;
      const res = yield call(serviceReq, payload);
      return res;
    },
    // 获取查询用户所有区划数据权限
    * getInspectionAllDistrictRule ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageQueryAllDistrictRuleGet, payload);
      return res;
    },
    // 获取查询用户所拥有的单位数据权限
    * getInspectionInstitutionRule ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageQueryDistrictOrgRulePost, payload);
      return res;
    },
    // 查询巡检次数
    * getInspectionLogCount ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionLogCountGet, payload);
      return res;
    },
    // 查询巡检风险类型
    * getInspectionRiskTypeList ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionRiskTypeGet, payload);
      return res;
    },
    // 事件重新打开
    * restartEvent ({ payload }, { call }) {
      const res = yield call(zlbApiSopTenantInspectionEventReopenEventNoGet, payload);
      return res;
    },
    // 事件催办
    * reminderEvent ({ payload }, { call }) {
      const res = yield call(zlbApiSopTenantInspectionRemindersEventNoGet, payload);
      return res;
    },
    // 事件详情
    * getDetailEvent ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionDetailEventNoGet, payload);
      return res;
    },
    // 事件业务数据
    * getEventBusinessData ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionEventPageGet, payload);
      return res;
    },
    // 事件转交
    * transferEvent ({ payload }, { call }) {
      const res = yield call(zlbApiSopOrgInspectionTransferPost, payload);
      return res;
    },
  },
   
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
